// User contributions about places: one-tap answers to attribute questions
// ("Dogs allowed here?") and problem reports ("doesn't exist"). v1 persists
// on-device and immediately personalizes the user's own app: answers render
// as chips, reported places are hidden from results.
//
// Cloud sync seam: when a Firebase web-app config lands, submit() should
// also write to Firestore (anonymous auth) so contributions aggregate into
// the enrichment pipeline as a "community" source. Until then everything
// is queued locally and exportContributions() can drain it.

const KEY = 'go-contributions-v1';

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) ?? [];
  } catch {
    return [];
  }
}

function save(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

function submit(entry) {
  const list = load();
  list.push({ ...entry, at: new Date().toISOString() });
  save(list);
  // future: also push to Firestore here
}

export function submitAnswer(place, attribute, value) {
  submit({
    kind: 'answer',
    placeId: place.id,
    placeName: place.name,
    lat: place.lat ?? null,
    lon: place.lon ?? null,
    attribute,
    value,
  });
}

export function submitReport(place, reason) {
  submit({
    kind: 'report',
    placeId: place.id,
    placeName: place.name,
    lat: place.lat ?? null,
    lon: place.lon ?? null,
    reason,
  });
}

export function getAnswersForPlace(placeId) {
  return load().filter((c) => c.kind === 'answer' && c.placeId === placeId);
}

export function isPlaceReported(placeId) {
  return load().some((c) => c.kind === 'report' && c.placeId === placeId);
}

/** Set of place ids the user has reported — used to hide them from results. */
export function getReportedPlaceIds() {
  return new Set(load().filter((c) => c.kind === 'report').map((c) => c.placeId));
}

/** Everything queued on this device (for future cloud sync / export). */
export function exportContributions() {
  return load();
}
